import { Injectable } from '@angular/core';
import { Observable, map } from 'rxjs';
import { DynamicForm } from '../../models/dynamic-form.model';
import { GenericService } from '../generic.service';
import { apiResponse } from '../../models/apiResponse';

@Injectable({
  providedIn: 'root'
})
export class DynamicFormService {
  constructor(private genericService: GenericService) {}

  getForms(): Observable<DynamicForm[]> {
    return this.genericService.get<apiResponse<DynamicForm[]>>('dynamic-form').pipe(
      map(response => response.result)
    );
  }

  getFormById(id: string): Observable<DynamicForm> {
    return this.genericService.get<apiResponse<DynamicForm>>(`dynamic-form/${id}`).pipe(
      map(response => response.result)
    );
  }

  saveForm(form: DynamicForm): Observable<DynamicForm> {
    if (form.id && form.id !== '') {
      return this.genericService.put<apiResponse<DynamicForm>>(`dynamic-form/${form.id}`, form).pipe(
        map(response => response.result)
      );
    } else {
      return this.genericService.post<apiResponse<DynamicForm>>('dynamic-form', form).pipe(
        map(response => response.result)
      );
    }
  }

  activateForm(id: string): Observable<any> {
    return this.genericService.put<apiResponse<any>>(`dynamic-form/${id}/activate`, {}).pipe(
      map(response => response.result)
    );
  }

  deactivateForm(id: string): Observable<any> {
    return this.genericService.put<apiResponse<any>>(`dynamic-form/${id}/deactivate`, {}).pipe(
      map(response => response.result)
    );
  }

}
